module.exports = __webpack_public_path__ + "static/media/loading.eb17f954.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/loading.gif
 ** module id = 908
 ** module chunks = 0
 **/